
<style >

  .c-p p{
    margin-top: 0px;
    margin-bottom: 3px;
  }
  .c-p1{
    font-size: 16px;
    font-weight: bold;
    color: #333;
  }
  .c-p2{
    color: #808080;
    font-size: 12px;
    margin-bottom: 0px !important;
  }

  .brand{
    text-align: center;
    padding: 20px 0;
  }

   .brand img{
     width:30px;
     
   }
   .brand span{
     display: block;
    font-size: 14px;
    font-weight: 700;
   }
  .cm{
    padding: 20px 0;
  }
  .cm p{
    margin-top: 0px;
    margin-bottom: 0px;
  }
  .cm p.cm-1{
    font-size: 16px;
    font-weight: bold;
    margin-bottom: 8px;
  }

  .cm p.cm-2{
    color: #000;
    font-size: 14px;
    font-weight: 700;
    line-height: 23px;
  }
  .cellp p{
    margin-top: 0px;
    margin-bottom: 1px;
  }
  
  .cellp .cp1{
    font-size: 19px;
  }
  .cellp .cp2{
    font-size: 12px;color: #808080;
  }
  .cellp .cp3{
    font-size: 13px;
  }
  .cellp .cp4{
    font-size: 16px;color: #DD403B;
  }

   .van-tabs__line{
    /* background-color: #DD403B;*/
  }
  .van-tab--active{
    /* color:#DD403B;*/
  }

  .van-tab--active span{
    display:initial;
    padding: 0 10px;
    font-size: 14px;
    color: #fff;
    background-image: linear-gradient(to right , #d76f6b, #c02b61);
    border-radius:5px;
  }

  .cbg{
    height: 250px;
    width: 90%;
  }

  .cellp .yhspan{
  	display: inline-block;
    border: 1px solid #E68F14;
    font-size: 12px;
    padding: 0px 4px 0px 4px;
    background-color: #E68F14;
    color: white;
    border-radius: 3px;
    transform: scale(0.9,0.9);
    line-height: 16px;
  }

  
  .swiper-pagination-bullet-active{
  	background: #fff !important;
  }

  .intro_popup{
    width: 90%;
  }

  .intro_popup .van-panel__header .van-cell__title{
    font-size: 14px;
    font-weight: bold;
  }
  
  .intro_popup .intro_content {
    padding: 20px;
  }

  .intro_popup .van-panel__footer div{
    text-align: right;
  }
  
</style>
<style scoped>
  .swiper-slide {
    margin-top: 45px;
    height: 170px;
    position: relative
  }

  .swiper-slide span.score{
    position: absolute;
    bottom: 0;
    right: 0;
    background: rgb(60, 134, 60);
    color: #fff;
    font-size: 10px;
    padding: 0 4px;
  }

  .swiper-slide img{
    width: 100%;
    height: 100%;
  }

  .swiper-pagination{
  	bottom:1px;
  }

  .swiper-slide-active{
    z-index: 999;
     transform: scale(1.10);
    border: 2px solid #c02b61;
    transition: transform .3s;
  }

  .opost{

  }
</style>
<template>
<div>
  <Head :leftarrow="true" :lroute="backs"></Head>
  <div class="me-center">
      <!--
    <van-cell-group>
      <van-cell @click.native="placedetail">
        <van-row type="flex" align="center">
          <van-col span="21">
            <div class="c-p">
              <p class="c-p1">{{movievalue.title}}</p>
              <p class="c-p2">{{movievalue.address}}</p>
            </div>
          </van-col>
          <van-col span="3" style="text-align: right;">
            <van-icon name="arrow" />
          </van-col>
        </van-row>
      </van-cell>
    </van-cell-group>
    -->
    
	<swiper :options="swiperOption" class="cbg" ref="swiper">
		<swiper-slide v-for="(item, index) in mresult" :key="index">
			<img v-bind:class="[swiperactive==index ? 'opost' : '']" :src="item.movie.poster"  />
      <span class="score" v-if="item.movie.fen > 0">{{item.movie.fen}}</span>
		</swiper-slide>
		<div class="swiper-pagination" slot="pagination"></div>
	</swiper>
    
    <van-row type="flex">
      <van-col span="8">
        <div class="brand" @click="showDescDialog=true">
          <img src="../static/icon_logo.png"/>
          <span>介绍</span>
        </div>
      </van-col>
      <van-col span="16">
        <div class="cm" v-if="load">
          <p class="cm-1">{{changevalue.movie.name}}</p>
          <p class="cm-2">{{changevalue.movie.duration}}分钟&nbsp;&nbsp;&nbsp;&nbsp;{{changevalue.movie.type}}</p>
          <p class="cm-2">{{changevalue.movie.cast}}</p>
        </div>
      </van-col>
    </van-row>
    
    <van-tabs v-model="active" :line-width="tabline" :line-height="tabline">
      <van-tab v-for="(item,index,a1) in changevalue.time" :key="a1" :title="index">
        <van-cell-group>
          <van-cell v-for="(item1,index1) in item" :key="index1" @click="uu(item1.channelShowCode,item1.cid,item1.id,item1.cineUpdateTime)">
            <van-row type="flex" class="cellp" align="center">
              <van-col span="6">
                <p class="cp1">{{item1.x_starttime}}</p>
                <p class="cp2">{{item1.x_endtime}} 散场</p>
              </van-col>
              <van-col span="6">
                <p class="cp3">{{item1.language}} {{item1.showType}}</p>
                <p class="cp2">{{item1.hallName}}</p>
              </van-col>
              <van-col style="text-align: center;" span="7">
              	<template v-if="api=='hln'">
              		<template v-if="item1.pbprice==0.0">
                		<span class="cp4">{{item1.realprice}}元</span>
                	</template>
                	<template v-else>
                		<span class="cp4" style="color: #E68F14;">{{item1.realprice}}元</span>
                		<span class="yhspan">连江商圈优惠价</span>
                	</template>
                </template>
                <template v-else>
                	<template v-if="item1.pbprice==0.0">
                		<span class="cp4">{{item1.realprice}}元</span>
                	</template>
                	<template v-else>
                		<span class="cp4" style="color: #E68F14;">{{item1.realprice}}元</span>
                		<span class="yhspan">连江商圈优惠价</span>
                	</template>
                </template>
              </van-col>
              <van-col style="text-align: center;" span="5" v-if="api=='hln'">
              	<template v-if="item1.realprice>item1.minPrice">
                	<span><van-button round plain size="mini" style="color: #DD403B;" type="danger" :data-cscode="item1.channelShowCode">购票</van-button></span>
                </template>
                <template v-else>
                	<span><van-button round plain size="mini" style="color: #E68F14;border: 1px solid #E68F14;" :data-cscode="item1.channelShowCode">特惠</van-button></span>
                </template>
              </van-col>
              <van-col style="text-align: center;" span="5" v-else>
              	<template v-if="item1.pbprice==0.0">
                	<span><van-button round plain size="mini" style="color: #DD403B;" type="danger" :data-cid="item1.cid" :data-playid="item1.id" :data-uptime="item1.cineUpdateTime">购票</van-button></span>
                </template>
                <template v-else>
                	<span><van-button round plain size="mini" style="color: #E68F14;border: 1px solid #E68F14;" :data-cid="item1.cid" :data-playid="item1.id" :data-uptime="item1.cineUpdateTime">特惠</van-button></span>
                </template>
              </van-col>
              
            </van-row>
          </van-cell>
        </van-cell-group>
      </van-tab>
    </van-tabs>
    
    
    <van-popup v-if="showDescDialog" v-model="showDescDialog" :lock-scroll="lockScroll" :close-on-click-overlay="closeOnClickOverlay" class="intro_popup">
      <van-panel :title="changevalue.movie.name">
        <van-cell-group>
          <van-cell title="影片类型" :value="changevalue.movie.type" />
          <van-cell title="影片语言" :value="changevalue.movie.language" />
          <van-cell title="时长（分钟）" :value="changevalue.movie.duration"/>
          <van-cell title="影片上映日期" :value="changevalue.movie.publishDate"/>
          <van-cell title="导演" :value="changevalue.movie.director" />
          <van-cell title="演员" :value="changevalue.movie.cast"/>
        </van-cell-group>
        <div class="intro_content">{{changevalue.movie.intro}}</div>
        <div slot="footer">
          <van-button size="small"  @click="showDescDialog=false">关闭</van-button>
        </div>
      </van-panel>
      
    </van-popup>
    </div>
    <Foot></Foot>
  </div>
</template>

<script>
  import Head from '@/components/Head.vue'
  import Foot from '@/components/Foot.vue'
  import 'swiper/dist/css/swiper.css'
	import { swiper, swiperSlide } from 'vue-awesome-swiper'
	
	let vm=null;
  export default {
	metaInfo: {
      meta: [
        { charset: 'utf-8' },
        { name: 'viewport', content: 'width=device-width, initial-scale=1, maximum-scale=1, minimum-scale=1, user-scalable=0, viewport-fit=cover' }
      ]
    },
    data(){
      return{
        movievalue:[],//跳转传入参数
        changevalue:[],//切换时改变的参数
        active: 0,
        swiperactive:0,
        mresult: [],
        load:false,
        tabline:0,
       // bg:require('../assets/1.jpg'),
        api:'hln',
        apivalue:'',
        swiperOption: {
          slidesPerView: 3,
          //spaceBetween: 20,
          centeredSlides: true,
          pagination: {
            el: '.swiper-pagination',
            clickable: true
          },
          on:{
          	slideChangeTransitionEnd(){
          		const activeIndex = this.activeIndex;
          		vm.onChange(activeIndex)
          		vm.swiperactive=activeIndex
          	}
          }
        },
        showDescDialog: false,
        lockScroll:false,
        closeOnClickOverlay:true,

      }
    },
    components: {
      Head,
      Foot,
      swiper,
      swiperSlide
    },
    created(){
    	vm=this
      this.movielist()
    },
    methods:{
      movielist(){
        var query=this.$route.params.v
        
        if(query==undefined){
          query=this.$mesessionstorage.get("chosemovieValue")
        }else{
          this.$mesessionstorage.set("chosemovieValue",query)
        }
        this.movievalue=query
        this.api=query.api
        if(query.api=='hln'){
          this.apivalue=query.hlnid
        }else if(query.api=='yky'){
          this.apivalue=query.ykyid
        }else{
          this.apivalue=query.fhid
        }
        this.$c.log(query)
        this.$http.post(this.$burl+'&c=movient&m=moviepian',{api:query.api,hlnid:query.hlnid,fhid:query.fhid,ykyid:query.ykyid})
        .then(res=>{
          var d=res.data
          this.mresult=d
          this.changevalue=d[0]
          this.load=true
          this.$refs.swiper.swipeTo(2)
          //this.$c.log(d)
        }).catch(()=>{})
      },
      onChange(index) {
        this.$c.log(index)
        this.changevalue=[]
        this.changevalue=this.mresult[index]
        console.log(this.changevalue);
      },
      placedetail(){
        this.$router.push({
          name: 'placedetail',
          params: {
            api:this.api,
            apivalue:this.apivalue
          }
        })
      },
      buy(e){
        //this.$c.log(e.target.dataset.cscode);
//      if(this.api=='hln'){
//        this.$mesessionstorage.set("chosezuoCscode",e.target.dataset.cscode)
//        this.$mesessionstorage.set("chosezuoApi",this.api)
//        this.$router.push({name: 'chosezuo',
//          params: {
//            cscode:e.target.dataset.cscode,
//            api:this.api
//          }
//        })
//      }else{
//        this.$mesessionstorage.set("chosezuoCid",e.target.dataset.cid)
//        this.$mesessionstorage.set("chosezuoPlayid",e.target.dataset.playid)
//        this.$mesessionstorage.set("chosezuoUptime",e.target.dataset.uptime)
//        this.$mesessionstorage.set("chosezuoApi",this.api)
//        this.$router.push({name: 'chosezuo',
//          params: {
//            cid:e.target.dataset.cid,
//            playid:e.target.dataset.playid,
//            uptime:e.target.dataset.uptime,
//            api:this.api
//          }
//        })
//      }
        
      },
      uu(a,b,c,d){
      	if(this.api=='hln'){
          this.$mesessionstorage.set("chosezuoCscode",a)
          this.$mesessionstorage.set("chosezuoApi",this.api)
          this.$router.push({name: 'chosezuo',
            params: {
              cscode:a,
              api:this.api
            }
          })
        }else if(this.api=='yky'){
          this.$mesessionstorage.set("chosezuoCscode",a)
          this.$mesessionstorage.set("chosezuoApi",this.api)
          this.$router.push({name: 'chosezuo',
            params: {
              cscode:a,
              api:this.api
            }
          })
        }else{
          this.$mesessionstorage.set("chosezuoCid",b)
          this.$mesessionstorage.set("chosezuoPlayid",c)
          this.$mesessionstorage.set("chosezuoUptime",d)
          this.$mesessionstorage.set("chosezuoApi",this.api)
          this.$router.push({name: 'chosezuo',
            params: {
              cid:b,
              playid:c,
              uptime:d,
              api:this.api
            }
          })
        }
      },
      backs(){
        this.$router.go(-1)
        return true;
      }
    }
  }
</script>